import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
import {
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  Icon,
} from "../../components/Component";
import {} from "reactstrap";
import BasePaginationTable from "../../components/table/BasePaginationTable";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { deletePostSuccess, getListPost } from "../../slice/posts";
import { defaultParams } from "../../constants";
import { deletePost } from "../../api/post";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../admin/modals/DeleteConfimationModal";
import { getDetailSuccess } from "../../slice/post-detail";
import TableActions from "../../components/table/TableActions";
import TableTime from "../../components/table/TableTime";
import TableUser from "../../components/table/TableUser";
import SortableHead, { nextSort } from "../../components/table/SortableHead";

function getDefaultColumns(onViewClick, onDeleteClick, sort, onSort) {
  return [
    {
      head: <span className="sub-text">{"Title"}</span>,
      cell: (row) => (
        <span
          style={{
            display: "block",
            maxWidth: 240,
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {row.title}
        </span>
      ),
    },
    {
      head: <span className="sub-text">{"Assets"}</span>,
      cell: (row) => {
        var asset = row.assets.length > 0 ? row.assets[0] : null;

        return (
          <>
            {asset &&
              (asset.type === "video" ? (
                <video
                  src={asset.link}
                  alt=""
                  autoPlay={false}
                  width={100}
                  style={{
                    objectFit: "cover",
                  }}
                />
              ) : (
                <img
                  src={asset.link}
                  alt="product-img"
                  width={100}
                  style={{
                    objectFit: "cover",
                  }}
                />
              ))}
          </>
        );
      },
    },
    {
      head: (
        <SortableHead
          label="Comments"
          order={sort.sortBy === "totalComments" ? sort.sortOrder : null}
          onClick={() => onSort("totalComments")}
        />
      ),
      cell: (row) => <span>{row.totalComments ?? 0}</span>,
    },
    {
      head: (
        <SortableHead
          label="Likes"
          order={sort.sortBy === "totalLiked" ? sort.sortOrder : null}
          onClick={() => onSort("totalLiked")}
        />
      ),
      cell: (row) => <span>{row.liked?.length ?? 0}</span>,
    },
    {
      head: <span className="sub-text">{"Created By"}</span>,
      cell: (row) => (
        <TableUser
          size="sm"
          avatar={row.createdBy?.avatar}
          name={
            row.createdBy?.displayName ||
            row.createdBy?.fullName ||
            row.createdBy?.businessName ||
            "No name"
          }
        />
      ),
    },
    {
      head: <span className="sub-text">{"Created at"}</span>,
      cell: (row) => <TableTime value={row?.createdAt} />,
    },
    {
      head: <span className="sub-text"></span>,
      cellClassName: "nk-tb-col-tools",
      cell: (row) => (
        <TableActions
          actions={[
            { label: "View", icon: "eye", onClick: () => onViewClick(row) },
            {
              label: "Delete",
              icon: "delete",
              danger: true,
              onClick: () => onDeleteClick(row),
            },
          ]}
        />
      ),
    },
  ];
}
const PostsPage = () => {
  const { list, summary, loading } = useSelector((state) => state.posts);
  const [smOption, setSmOption] = useState(false);
  const [params, setParams] = useState(defaultParams);
  const dispatch = useDispatch();
  const [isPostModalVisible, setPostModalVisible] = useState({
    post: null,
    delete: false,
  });
  const navigate = useNavigate();
  const goToDetail = (post) => {
    dispatch(getDetailSuccess(post));
    navigate(`/posts/${post._id}`);
  };
  const closeModal = () => {
    setPostModalVisible({
      post: null,
      delete: false,
    });
  };
  const onDelete = (post) => {
    setPostModalVisible({ post, delete: true });
  };
  useEffect(() => {
    dispatch(getListPost(params));
  }, [dispatch, params]);
  // Sorting restarts from the first page.
  const onSort = (key) =>
    setParams((prev) => ({ ...prev, page: 1, ...nextSort(prev, key) }));
  const dataTableColumns = getDefaultColumns(
    goToDetail,
    onDelete,
    params,
    onSort,
  );

  const _handleInputChange = (value) => {
    setParams((prev) => ({
      ...prev,
      keyword: value,
    }));
  };
  const handleInputChange = debounce(_handleInputChange, 500);
  const handlePageChange = (page) => {
    setParams({
      ...params,
      page,
    });
  };
  const onDeletePost = async () => {
    try {
      await deletePost(isPostModalVisible.post?._id);
      dispatch(deletePostSuccess(isPostModalVisible.post));
      toast.success("Delete post successfully");
    } catch (error) {
      toast.error(error);
    }
  };
  return (
    <React.Fragment>
      <Head title="Posts"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Posts</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Search by name"
                          onChange={(e) => handleInputChange(e.target.value)}
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <BasePaginationTable
          list={list}
          loading={loading}
          columns={dataTableColumns}
          onPageChange={handlePageChange}
          onRowClick={goToDetail}
          hasNextPage={summary?.hasNextPage}
          totalItems={summary?.count}
          {...params}
        />
      </Content>
      <DeleteConfirmationModal
        onConfirm={onDeletePost}
        isOpen={isPostModalVisible.delete}
        onCloseModal={closeModal}
      />
    </React.Fragment>
  );
};

export default PostsPage;
